<script lang="ts">
	import { Container, Input, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let editableObject;
</script>

<Container padding="scrollPadding">
	<Input
		class="mt-l mb-l mr-l"
		icon="fas fa-user"
		bind:value={editableObject.profileName}
		autofocus={true}
		size="l"
		label="Name"
		id="input-vsxt41h"
		aria-labelledby="input-vsxt41h"
	/>
</Container>
